module.exports = __webpack_public_path__ + "static/img/emoji_5.cf5fab2b.png";